module.exports = __webpack_public_path__ + "static/media/mk.9f0fdc91.webp";